// extracted by mini-css-extract-plugin
export var borderRadius = "_6k-4";
export var large = "_6k-3";
export var logoContainer = "_6k-0";
export var nameLogo = "_6k-2";
export var small = "_6k-1";